import { render, staticRenderFns } from "./MemberDiscountList.vue?vue&type=template&id=043083f0&"
import script from "./MemberDiscountList.vue?vue&type=script&lang=js&"
export * from "./MemberDiscountList.vue?vue&type=script&lang=js&"
import style0 from "./MemberDiscountList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports